// extracted by mini-css-extract-plugin
export default {"content":"verify-otp_content__Naok1","description":"verify-otp_description__4XKa-","footer":"verify-otp_footer__ZGBZd","label":"verify-otp_label__gwZqf"};